import _ from 'lodash';
import findIndex from './findIndex'



//this function is for master devices which can inject delete data from the given customized array. 
export default function (path, searchingData, injectionData, action) {
	let pathArray = [];
	let add = '';
	for (let i = 0; i < path.length; i++) {
		if (path[i] === '/') {
			if (path[i + 2] === '/') {
				add = add + path[i + 1];
			} else if (path[i + 3] === '/') {
				add = add + path[i + 1] + path[i + 2]
			} else if (path[i + 4] === '/') {
				add = add + path[i + 1] + path[i + 2] + path[i + 3]
			} else if (i + 2 === path.length || i + 3 === path.length || i + 4 === path.length) {
				add = add + (path[i + 1] || '') + (path[i + 2] || '') + (path[i + 3] || '');
			}
		}
		if (add !== '') {
			pathArray.push(Number(add));
		}
		add = ''
	}
	let indexForNow = 0;

	if (action === 'add') {
		switch (pathArray.length) {
			case 0:
				break;
			case 1:
				indexForNow = findIndex(searchingData, path)
				searchingData[indexForNow].paramField = injectionData
				break;
			case 2:
				indexForNow = findIndex(searchingData[pathArray[0]].paramValues, path)
				searchingData[pathArray[0]].paramValues[indexForNow].paramField = injectionData
				break;
			case 3:
				indexForNow = findIndex(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues, path)
				searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[indexForNow].paramField = injectionData
				break;
			case 4:
				indexForNow = findIndex(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues, path)
				searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[indexForNow].paramField = injectionData
				break;
			case 5:
				indexForNow = findIndex(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues, path);
				searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[indexForNow].paramField = injectionData
			case 6:
				indexForNow = findIndex(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues, path)
				searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues[indexForNow].paramField = injectionData
				break;
			case 7:
				indexForNow = findIndex(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues[pathArray[6]].paramValues, path)
				searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues[pathArray[5]].paramValues[indexForNow].paramField = injectionData
				break;
			case 8:
				indexForNow = findIndex(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues[pathArray[6]].paramValues[pathArray[7]].paramValues, path)
				searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues[pathArray[5]].paramValues[pathArray[6]].paramValues[indexForNow].paramField = injectionData
				break;
			case 9:
				indexForNow = findIndex(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues[pathArray[6]].paramValues[pathArray[7]].paramValues[pathArray[8]].paramValues, path)
				searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues[pathArray[5]].paramValues[pathArray[6]].paramValues[pathArray[7]].paramValues[indexForNow].paramField = injectionData
				break;
			case 10:
				indexForNow = findIndex(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues[pathArray[6]].paramValues[pathArray[7]].paramValues[pathArray[8]].paramValues[pathArray[9]].paramValues, path)
				searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues[pathArray[5]].paramValues[pathArray[6]].paramValues[pathArray[7]].paramValues[pathArray[8]].paramValues[indexForNow].paramField = injectionData
				break;
		}
		return searchingData;
	} else if (action === 'delete') {
		switch (pathArray.length) {
			case 0:
				console.log('worked');
				break;
			case 1:
				indexForNow = findIndex(searchingData, path)
				_.pullAt(searchingData, [indexForNow])
			
				break;
			case 2:
				indexForNow = findIndex(searchingData[pathArray[0]].paramValues, path)
				_.pullAt(searchingData[pathArray[0]].paramValues, [indexForNow])
				break;
			case 3:
				indexForNow = findIndex(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues, path)
				_.pullAt(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues, [indexForNow])
				break;
			case 4:
				indexForNow = findIndex(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues, path)
				_.pullAt(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues, [indexForNow])
				break;
			case 5:
				indexForNow = findIndex(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues, path);
				_.pullAt(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues, [indexForNow])
				break;
			case 6:
				indexForNow = findIndex(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues, path)
				_.pullAt(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues, [indexForNow])
				break;
			case 7:
				indexForNow = findIndex(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues[pathArray[6]].paramValues, path)
				_.pullAt(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues[pathArray[6]].paramValues, indexForNow)
				break;
			case 8:
				indexForNow = findIndex(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues[pathArray[6]].paramValues[pathArray[7]].paramValues, path)
				_.pullAt(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues[pathArray[6]].paramValues[pathArray[7]].paramValues, indexForNow)
				break;
			case 9:
				indexForNow = findIndex(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues[pathArray[6]].paramValues[pathArray[7]].paramValues[pathArray[8]].paramValues, path)
				_.pullAt(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues[pathArray[6]].paramValues[pathArray[7]].paramValues[pathArray[8]].paramValues, indexForNow)
				break;
			case 10:
				indexForNow = findIndex(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues[pathArray[6]].paramValues[pathArray[7]].paramValues[pathArray[8]].paramValues[pathArray[9]].paramValues, path)
				_.pullAt(searchingData[pathArray[0]].paramValues[pathArray[1]].paramValues[pathArray[2]].paramValues[pathArray[3]].paramValues[pathArray[4]].paramValues[pathArray[6]].paramValues[pathArray[7]].paramValues[pathArray[8]].paramValues[pathArray[9]].paramValues, indexForNow)
				break;
		}
		console.log(searchingData);
		 searchingData = updatePath(searchingData, 'root');
		return searchingData;
	}
}

const updatePath = (data, prefixPath) => {
	let someData = [];
	data.forEach((outerElement, index)=>{
		console.log(outerElement)
		if(outerElement.paramValues.length!==0){
				let tempData = {
				...outerElement,
				path: prefixPath+ '/' + index,
				// paramValues: updatePath(outerElement.paramValues, outerElement.path )
			}
			someData.push(tempData)			
			someData[someData.length-1].paramValues = updatePath(someData[someData.length-1].paramValues, someData[someData.length-1].path )
			
		}else if(outerElement.paramValues.length===0){
			let tempData = {
				...outerElement,
				path: prefixPath + '/' + index,
			}
			someData.push(tempData)		
		}
	})	
	return someData
}